import { Link, useLocation } from "react-router-dom";
import { ChevronRight, Search } from "lucide-react";

const CLOUD_LOGO = "https://customer-assets.emergentagent.com/job_eamico-core/artifacts/jlqt1nkd_Coding%20and%20design%20harmony%20%282%29.png";

const sections = [
  {
    title: "Getting Started",
    items: [
      { label: "Quick Start", path: "/docs/getting-started/quick-start" },
      { label: "Account Setup", path: "/docs/getting-started/account-setup" },
      { label: "Your First Project", path: "/docs/getting-started/first-project" },
      { label: "First Deployment", path: "/docs/getting-started/first-deployment" },
    ],
  },
  {
    title: "Eamico Cloud",
    items: [
      { label: "Overview", path: "/docs/cloud/overview" },
      { label: "The Aethernet", path: "/docs/cloud/aethernet" },
      { label: "Edge Network", path: "/docs/cloud/edge-network" },
      { label: "Custom Domains", path: "/docs/cloud/custom-domains" },
      { label: "SSL Certificates", path: "/docs/cloud/ssl" },
      { label: "Environment Variables", path: "/docs/cloud/env-variables" },
      { label: "Analytics", path: "/docs/cloud/analytics" },
    ],
  },
  {
    title: "Compute",
    items: [
      { label: "Overview", path: "/docs/compute/overview" },
      { label: "Machine Tiers", path: "/docs/compute/tiers" },
      { label: "Resource Monitoring", path: "/docs/compute/monitoring" },
    ],
  },
  {
    title: "Deployment",
    items: [
      { label: "Quick Deploy", path: "/docs/deployment/quick-deploy" },
      { label: "Cloudflare Pages", path: "/docs/deployment/cloudflare" },
      { label: "Vercel", path: "/docs/deployment/vercel" },
      { label: "Netlify", path: "/docs/deployment/netlify" },
      { label: "Rollbacks", path: "/docs/deployment/rollbacks" },
    ],
  },
  {
    title: "CLI Reference",
    items: [
      { label: "Installation", path: "/docs/cli/installation" },
      { label: "Commands", path: "/docs/cli/commands" },
      { label: "Configuration", path: "/docs/cli/configuration" },
    ],
  },
  {
    title: "API Reference",
    items: [
      { label: "Authentication", path: "/docs/api/authentication" },
      { label: "Projects", path: "/docs/api/projects" },
      { label: "Deployments", path: "/docs/api/deployments" },
      { label: "Webhooks", path: "/docs/api/webhooks" },
      { label: "Rate Limits", path: "/docs/api/rate-limits" },
    ],
  },
  {
    title: "Security",
    items: [
      { label: "Authentication & 2FA", path: "/docs/security/authentication" },
      { label: "Encryption", path: "/docs/security/encryption" },
      { label: "Compliance", path: "/docs/security/compliance" },
      { label: "Audit Logs", path: "/docs/security/audit-logs" },
    ],
  },
  {
    title: "Billing",
    items: [
      { label: "Plans & Pricing", path: "/docs/billing/plans" },
      { label: "Payment Methods", path: "/docs/billing/payment" },
      { label: "Invoices", path: "/docs/billing/invoices" },
    ],
  },
];

const DocsLayout = ({ children }) => {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-white pt-[94px]" data-testid="docs-layout">
      <div className="max-w-[1440px] mx-auto flex">
        {/* Sidebar */}
        <aside className="hidden lg:block w-72 shrink-0 border-r border-[#e8eaed] h-[calc(100vh-64px)] sticky top-16 overflow-y-auto py-6 px-6" data-testid="docs-sidebar">
          {/* Search */}
          <div className="relative mb-6">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#9aa0a6]" />
            <input
              type="text"
              placeholder="Search docs..."
              className="w-full pl-9 pr-3 py-2 text-[13px] bg-[#f8f9fa] rounded-lg border border-[#e8eaed] focus:border-[#ff9a4d] focus:ring-1 focus:ring-[#ff9a4d] outline-none"
              data-testid="docs-sidebar-search"
            />
          </div>

          <nav className="space-y-6">
            {sections.map((section) => (
              <div key={section.title}>
                <p className="text-[11px] font-bold text-[#202124] tracking-wide uppercase mb-2 px-2">
                  {section.title}
                </p>
                <ul className="space-y-0.5">
                  {section.items.map((item) => {
                    const isActive = location.pathname === item.path;
                    return (
                      <li key={item.path}>
                        <Link
                          to={item.path}
                          className={`block px-2 py-1.5 text-[13px] rounded-md transition-colors ${
                            isActive
                              ? "text-[#ff9a4d] bg-[#fff4eb] font-medium"
                              : "text-[#5f6368] hover:text-[#202124] hover:bg-[#f8f9fa]"
                          }`}
                        >
                          {item.label}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
            ))}
          </nav>
        </aside>

        {/* Content */}
        <div className="flex-1 min-w-0">
          {children}
        </div>
      </div>
    </div>
  );
};

export default DocsLayout;
export { sections };
